<template>
  <div>
    <div class="container">
      <div class="stable-nav">
        <LeftNav></LeftNav>
      </div>
      <div class="change-content">
        <div class="header-panel">
          <headerNav></headerNav>
        </div>
        <div class="crumbs flex align-center">
          <crumbs></crumbs>
        </div>
        <keep-alive :include="include">
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <template v-if="!$route.meta.keepAlive">
          <router-view></router-view>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import headerNav from "@/components/common/headerNav";
import LeftNav from "@/components/common/left-nav";
import crumbs from "@/components/common/crumbs";

export default {
  name: "layout",
  components: {
    headerNav,
    LeftNav,
    crumbs
  },
  data() {
    return {
      include: ['fuxinSend'],
    };
  },
  created(){
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to)
        console.log(from)
        try {
          // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
          if (to.meta.keepAlive) {
            !this.include.includes(to.name) && this.include.push(to.name);
          } else {
            //进入不需要缓存的页面把 include  清除
            this.include = [];
          }
          // 如果 要 form(离开) 的页面是 keepAlive缓存的，
          // 再根据 deepth 来判断是前进还是后退
          // 如果是后退：
          if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
            const index = this.include.indexOf(from.name);
            index !== -1 && this.include.splice(index, 1);
          }
        } catch (error) {}
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.crumbs{
  height: .46rem;
  padding-left: .3rem;
  border-bottom: 1px solid rgba(145,145,148,.15);
}
</style>



// WEBPACK FOOTER //
// src/components/common/layout.vue